module.exports = __webpack_public_path__ + "static/media/e95b8c2fb23b14b5e73f52abadf3a8e3.2c5a5ca6.svg";